import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getSessions } from "services/ConfigServices";
import { sessiontext } from "variables/MBM/session";
import { sessiontypeData } from "variables/MBM/lists/session";
import moment from "moment";

import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddSession from "./AddSession";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useSessionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype == 1;
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getSessions(chartIdGroup);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [sessionsData, setSessionsData] = useState([]);
  const [sessions, setSessions] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );

        setResults(response.data);
        setSessionsData(response.data.sessions);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `sessions`, []).filter(
    (item) =>
      (item.id && (""+item.id).toLowerCase().includes(filterText.toLowerCase())) ||
      (item.watchperiod && (""+item.watchperiod).toLowerCase().includes(filterText.toLowerCase())) ||
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.handlerguid && item.handlerguid.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.sessiontype && sessiontypeData.find((x) => x.id == item.sessiontype) && sessiontypeData.find((x) => x.id == item.sessiontype).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.laststatustime && moment(item.laststatustime).isValid() && moment(item.laststatustime).format("DD/MM/YYYY hh:mm:ss").includes(filterText)) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = sessions.map((item) => {
      let sessionexport = {};
      sessionexport[sessiontext.id] = item.id;
      sessionexport[sessiontext.handlerid] = item.handlerguid;
      sessionexport[sessiontext.type] = sessiontypeData.find((x) => x.id == item.sessiontype)?.name;
      sessionexport[sessiontext.name] = item.name;
      sessionexport[sessiontext.watchperiod] = item.watchperiod;
      sessionexport[sessiontext.group] = groupInfoListById["" + item.groupid];
      sessionexport[sessiontext.equipmentcount] = item.equipmentcount;
      sessionexport[sessiontext.laststatustime] = (item.laststatustime && moment(item.laststatustime).isValid()) ? moment(item.laststatustime).format("DD/MM/YYYY hh:mm:ss") : "";
      sessionexport[sessiontext.laststatus] = item.laststatus || 0;
      sessionexport[sessiontext.sessionurl] = item.sessionurl;
      sessionexport[sessiontext.rooturl] = item.rootobjecturl;
      return sessionexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbm_admin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddSession refetch={refreshTable} onClick={handleClear} />
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!sessions || sessions.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, sessionsData, sessions]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSessions
  };
}
